import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import TableSellInvoicesRefund from '../../../../../../../specificComponents/sells/TableSellInvoiceRefund'
import NullComponent from '../../../../../../../baseComponents/NullComponent'
import { Link } from 'react-router-dom'
import { ButtonSecondary } from '../../../../../../../baseComponents/Button'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import locations from '../../../../../../../utils/globals/locations'
import PermissionChecker from '../../../../../../../baseComponents/PermissionChecker'
import { getUserPermissions } from '../../../../../../../utils/reducers/getters'

interface SellInvoicesRefundProps extends ComponentWithPermissions { }

const SellInvoicesRefund: React.FC<SellInvoicesRefundProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('invoicesRefund', 'Devolución de facturas'),
        newText: '',
    }

    return (
        <BaseScreenTable TableComponent={TableSellInvoicesRefund} CreateModalComponent={NullComponent} pageData={pageData} userPermissions={userPermissions} RightHeader={<GenerateMultiInvoiceRefundButton/>} />
    )
}


const GenerateMultiInvoiceRefundButton = () => {
    return (
        <PermissionChecker userPermissions={getUserPermissions('sell.refundInvoice')} permission={'create'}>
            <Link to={locations.sellInvoiceRefundMulti + '/main'}>
                <ButtonSecondary className='mr-10'>
                    <TwinTrans transKey='generateMultiInvoiceRefund'> Generar devolución de factura múltiple</TwinTrans>
                </ButtonSecondary>
            </Link>
        </PermissionChecker>
    )
}

export default SellInvoicesRefund